const PubSub = require("underpub-js");
const { gsap } = require("gsap/dist/gsap");
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

gsap.registerPlugin(ScrollTrigger);

const header = function(options) {
	this.options = {
		$el: false,
	};

	$.extend(true, this.options, options);

	this.data = {
		baseClass: "comp-Header",
		navIsOpen: false,
		windowWidth: undefined,
		backgroundColor: "#1E1E1E",
	};

	this.navTL;
};

header.prototype.init = function() {
	const self = this;

	self.$header = self.options.$el;
	self.data.headerIsTransparent = self.$header.hasClass(
		`${self.data.baseClass}--transparent`,
	);
	self.$mobileNav = self.$header.find(`.${self.data.baseClass}__mobile-nav`);
	self.$mobileNavMenuItems = self.$header.find(
		`.${self.data.baseClass}__mobile-nav__menu > li`,
	);
	self.$socialIcons = self.$header.find(
		`.${self.data.baseClass}__mobile-nav__social li`,
	);
	self.$hamburger = self.$header.find(`.${self.data.baseClass}__hamburger`);
	self.$hamburger.on("click", () => self.toggleNav());
	self.initNavTL();

	PubSub.subscribe("resize", () => self.closeNav(1.85));

	self.initScrollToggle();

	self.$activeDropdown = null;
	self.$dropdownToggles = self.options.$el.find(`.${self.data.baseClass}__primaryNavigation__dropdownToggle, .${self.data.baseClass}__secondaryNavigation__dropdownToggle`);
	
	self.$activeMobileDropdown = null;
	self.$mobileDropdownToggles = self.options.$el.find(`.${self.data.baseClass}__mobile-nav__menu__dropdownToggle`);
	// self.$dropdowns = self.options.$el.find(`.${self.data.baseClass}__primaryNavigation__dropdown, .${self.data.baseClass}__secondaryNavigation__dropdown`);

	self.initDropdowns();
	self.initMobileDropdowns();

};

header.prototype.initMobileDropdowns = function() {

	const self = this;

	self.$mobileDropdownToggles.on('click', function() {

		let $dropdown = $(this).next();

		if ($dropdown.is(self.$activeMobileDropdown)) {
			self.closeMobileDropdown($dropdown);
			self.$activeMobileDropdown = null;
		}
		else {
			if (self.$activeMobileDropdown !== null) {
				self.closeMobileDropdown(self.$activeMobileDropdown);
			}
			self.openMobileDropdown($dropdown);
			self.$activeMobileDropdown = $dropdown;
		}

	});

};

header.prototype.openMobileDropdown = function($dropdown) {

	const self = this;

	let $dropdownToggleArrow = $dropdown.prev().find(`.${self.data.baseClass}__mobile-nav__menu__dropdownToggle__arrow`);

	gsap.timeline({

	})
	.to($dropdown, {
		duration: 0.35,
		height: "auto"
	})
	.to($dropdownToggleArrow, {
		duration: 0.35,
		rotation: 180
	}, "<");
	

};

header.prototype.closeMobileDropdown = function($dropdown) {

	const self = this;

	let $dropdownToggleArrow = $dropdown.prev().find(`.${self.data.baseClass}__mobile-nav__menu__dropdownToggle__arrow`);

	gsap.timeline({

	})
	.to($dropdown, {
		duration: 0.25,
		height: 0
	})
	.to($dropdownToggleArrow, {
		duration: 0.25,
		rotation: 0
	}, "<");

};

header.prototype.initDropdowns = function() {

	const self = this;

	self.$dropdownToggles.on('click', function() {

		let $dropdown = $(this).next();

		if ($dropdown.is(self.$activeDropdown)) {
			self.closeDropdown($dropdown);
			self.$activeDropdown = null;
		}
		else {
			if (self.$activeDropdown !== null) {
				self.closeDropdown(self.$activeDropdown);
			}
			self.openDropdown($dropdown);
			self.$activeDropdown = $dropdown;
		}

	});

};

header.prototype.openDropdown = function($dropdown) {

	const self = this;

	let $dropdownToggleArrow = $dropdown.prev().find(`.${self.data.baseClass}__primaryNavigation__dropdownToggle__arrow, .${self.data.baseClass}__secondaryNavigation__dropdownToggle__arrow`);

	if ($dropdown.hasClass(`${self.data.baseClass}__primaryNavigation__dropdown`)) {
		gsap.timeline({

		})
		.set($dropdown, {
			visibility: 'visible'
		})
		.to($dropdown, {
			duration: 0.35,
			opacity: 1,
			y: 0,
		})
		.to($dropdownToggleArrow, {
			duration: 0.35,
			rotation: 180
		}, "<");
	}
	else if ($dropdown.hasClass(`${self.data.baseClass}__secondaryNavigation__dropdown`)) {
		gsap.timeline({

		})
		.set($dropdown, {
			visibility: 'visible'
		})
		.to($dropdown, {
			duration: 0.35,
			height: "auto"
		})
		.to($dropdownToggleArrow, {
			duration: 0.35,
			rotation: 180
		}, "<");
	}

};

header.prototype.closeDropdown = function($dropdown) {

	const self = this;

	let $dropdownToggleArrow = $dropdown.prev().find(`.${self.data.baseClass}__primaryNavigation__dropdownToggle__arrow, .${self.data.baseClass}__secondaryNavigation__dropdownToggle__arrow`);

	if ($dropdown.hasClass(`${self.data.baseClass}__primaryNavigation__dropdown`)) {
		gsap.timeline({

		})
		.to($dropdown, {
			duration: 0.25,
			opacity: 0,
			y: 20,
		})
		.to($dropdownToggleArrow, {
			duration: 0.25,
			rotation: 0
		}, "<")
		.set($dropdown, {
			visibility: 'hidden'
		});
	}
	else if ($dropdown.hasClass(`${self.data.baseClass}__secondaryNavigation__dropdown`)) {
		gsap.timeline({

		})
		.to($dropdown, {
			duration: 0.25,
			height: 0
		})
		.to($dropdownToggleArrow, {
			duration: 0.25,
			rotation: 0
		}, "<")
		.set($dropdown, {
			visibility: 'hidden'
		});
	}

};

header.prototype.initScrollToggle = function() {
	const self = this;

	gsap
		.timeline({
			scrollTrigger: {
				// trigger: self.options.$el,
				start: "100",
				toggleActions: "play none none reverse",
				// markers: true,
			},
		})
		.to(self.$header, {
			duration: 0.4,
			backgroundColor: self.data.backgroundColor,
		});
};

header.prototype.generateHamburgerTL = function() {
	const self = this;
	const $hamburger = self.$hamburger;
	const $line = $hamburger.find(".line");
	const $top = $hamburger.find(".top");
	const $topLine = $top.find($line);
	const $middle = $hamburger.find(".middle");
	const $middleLine = $top.find($line);
	const $bottom = $hamburger.find(".bottom");
	const $bottomLine = $bottom.find($line);

	const tl = gsap
		.timeline()
		.to([$top, $bottom], {
			duration: 0.2,
			top: "50%",
		})
		.to(
			$middle,
			{
				duration: 0.2,
				opacity: 0,
			},
			"<",
		)
		.set($line, {
			backgroundColor: "#FF6700",
		})
		.to(
			$hamburger,
			{
				duration: 0.2,
				scale: 1.2,
			},
			"",
		)
		.to(
			$topLine,
			{
				duration: 0.2,
				rotate: 45,
				yPercent: 50,
			},
			"<",
		)
		.to(
			$bottomLine,
			{
				duration: 0.2,
				rotate: -45,
				yPercent: 50,
			},
			"<",
		);

	return tl;
};

header.prototype.generateNavMenuTL = function() {
	const self = this;

	const tl = gsap
		.timeline()
		.set(self.$mobileNav, {
			visibility: "visible",
		})
		.from(self.$mobileNav, {
			xPercent: 100,
			duration: 0.8,
			ease: "expo.out",
		})
		.from(
			self.$mobileNavMenuItems,
			{
				duration: 0.6,
				stagger: 0.045,
				ease: "expo.out",
				opacity: 0,
				y: 20,
			},
			"<.215",
		)
		.from(
			self.$socialIcons,
			{
				duration: 0.3,
				stagger: 0.03,
				opacity: 0,
				x: 10,
			},
			"<.2",
		);

	return tl;
};

header.prototype.initNavTL = function() {
	const self = this;

	self.navTL = gsap.timeline({
		paused: true,
		reversed: true,
		onStart: () => self.toggleNavState(),
		onReverseComplete: () => self.toggleNavState(),
	});

	const hamburgerTL = self.generateHamburgerTL();
	const navMenuTL = self.generateNavMenuTL();

	self.navTL.add(hamburgerTL, 0).add(navMenuTL, 0.15);
};

header.prototype.toggleNavState = function() {
	const self = this;

	self.data.navIsOpen = !self.data.navIsOpen;
};

header.prototype.openNav = function(speed = 1) {
	const self = this;

	if (self.data.navIsOpen || self.navTL.isActive()) return;

	self.navTL.timeScale(speed).play();
};

header.prototype.closeNav = function(speed = 1.4) {
	const self = this;

	if (!self.data.navIsOpen || self.navTL.isActive()) return;

	self.navTL.timeScale(speed).reverse();
};

header.prototype.toggleNav = function() {
	const self = this;

	self.navTL.reversed() ? self.openNav() : self.closeNav();
};

module.exports = header;
